/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { AwbMode_Enum, awbMode_EnumFromJSON, awbMode_EnumToJSON } from "../../../../gen/user_camera/awb_mode";
import {
  ExposureMode_Enum,
  exposureMode_EnumFromJSON,
  exposureMode_EnumToJSON,
} from "../../../../gen/user_camera/exposure_mode";
import { IsoMode_Enum, isoMode_EnumFromJSON, isoMode_EnumToJSON } from "../../../../gen/user_camera/iso_mode";
import { CameraSettings } from "../../mission_camera_settings";
import { FreeLookMode_Enum, freeLookMode_EnumFromJSON, freeLookMode_EnumToJSON } from "../../waypoints";

export const protobufPackage = "skills";

/** Arguments for starting video recording. */
export interface StartVideoActionArgs {
  /**
   * Desired iso mode for taking video. This field is deprecated. Use camera_settings field instead.
   *
   * @deprecated
   */
  isoMode: IsoMode_Enum;
  /**
   * Desired exposure mode for taking video. This field is deprecated. Use camera_settings field
   * instead.
   *
   * @deprecated
   */
  exposureMode: ExposureMode_Enum;
  /**
   * Desired auto white balance mode for taking video. This field is deprecated. Use camera_settings
   * field instead.
   *
   * @deprecated
   */
  awbMode: AwbMode_Enum;
  /**
   * Desired camera settings for taking video. Includes iso mode, exposure mode, and auto white
   * balance mode.
   */
  cameraSettings:
    | CameraSettings
    | undefined;
  /** Allow free look to persist during the start video action. */
  freeLookMode: FreeLookMode_Enum;
}

export interface StartVideoResultData {
}

export interface StartVideoActionStateData {
}

function createBaseStartVideoActionArgs(): StartVideoActionArgs {
  return { isoMode: 0, exposureMode: 0, awbMode: 0, cameraSettings: undefined, freeLookMode: 0 };
}

export const StartVideoActionArgs = {
  encode(message: StartVideoActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.isoMode !== 0) {
      writer.uint32(8).int32(message.isoMode);
    }
    if (message.exposureMode !== 0) {
      writer.uint32(16).int32(message.exposureMode);
    }
    if (message.awbMode !== 0) {
      writer.uint32(24).int32(message.awbMode);
    }
    if (message.cameraSettings !== undefined) {
      CameraSettings.encode(message.cameraSettings, writer.uint32(34).fork()).ldelim();
    }
    if (message.freeLookMode !== 0) {
      writer.uint32(40).int32(message.freeLookMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StartVideoActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartVideoActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.isoMode = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.exposureMode = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.awbMode = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.cameraSettings = CameraSettings.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.freeLookMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartVideoActionArgs {
    return {
      isoMode: isSet(object.isoMode) ? isoMode_EnumFromJSON(object.isoMode) : 0,
      exposureMode: isSet(object.exposureMode) ? exposureMode_EnumFromJSON(object.exposureMode) : 0,
      awbMode: isSet(object.awbMode) ? awbMode_EnumFromJSON(object.awbMode) : 0,
      cameraSettings: isSet(object.cameraSettings) ? CameraSettings.fromJSON(object.cameraSettings) : undefined,
      freeLookMode: isSet(object.freeLookMode) ? freeLookMode_EnumFromJSON(object.freeLookMode) : 0,
    };
  },

  toJSON(message: StartVideoActionArgs): unknown {
    const obj: any = {};
    if (message.isoMode !== 0) {
      obj.isoMode = isoMode_EnumToJSON(message.isoMode);
    }
    if (message.exposureMode !== 0) {
      obj.exposureMode = exposureMode_EnumToJSON(message.exposureMode);
    }
    if (message.awbMode !== 0) {
      obj.awbMode = awbMode_EnumToJSON(message.awbMode);
    }
    if (message.cameraSettings !== undefined) {
      obj.cameraSettings = CameraSettings.toJSON(message.cameraSettings);
    }
    if (message.freeLookMode !== 0) {
      obj.freeLookMode = freeLookMode_EnumToJSON(message.freeLookMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartVideoActionArgs>, I>>(base?: I): StartVideoActionArgs {
    return StartVideoActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartVideoActionArgs>, I>>(object: I): StartVideoActionArgs {
    const message = createBaseStartVideoActionArgs();
    message.isoMode = object.isoMode ?? 0;
    message.exposureMode = object.exposureMode ?? 0;
    message.awbMode = object.awbMode ?? 0;
    message.cameraSettings = (object.cameraSettings !== undefined && object.cameraSettings !== null)
      ? CameraSettings.fromPartial(object.cameraSettings)
      : undefined;
    message.freeLookMode = object.freeLookMode ?? 0;
    return message;
  },
};

function createBaseStartVideoResultData(): StartVideoResultData {
  return {};
}

export const StartVideoResultData = {
  encode(_: StartVideoResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StartVideoResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartVideoResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): StartVideoResultData {
    return {};
  },

  toJSON(_: StartVideoResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<StartVideoResultData>, I>>(base?: I): StartVideoResultData {
    return StartVideoResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartVideoResultData>, I>>(_: I): StartVideoResultData {
    const message = createBaseStartVideoResultData();
    return message;
  },
};

function createBaseStartVideoActionStateData(): StartVideoActionStateData {
  return {};
}

export const StartVideoActionStateData = {
  encode(_: StartVideoActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StartVideoActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartVideoActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): StartVideoActionStateData {
    return {};
  },

  toJSON(_: StartVideoActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<StartVideoActionStateData>, I>>(base?: I): StartVideoActionStateData {
    return StartVideoActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartVideoActionStateData>, I>>(_: I): StartVideoActionStateData {
    const message = createBaseStartVideoActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
